import { ImageCircle } from 'components/orderSummary/components/imageCircle/imageCircle';
import 'components/orderSummary/components/cartItem/cartItem.scss';
import template from './cartItem.html';

export const CartItem = angular
    .module('checkout.components.volt.orderSummary.cartItem', [
        ImageCircle
    ]).component('voltCartItem', {
        template,
        bindings: {
            quantity: '<',
            listPrice: '<',
            salePrice: '<',
            isOnSale: '<',
            productName: '<',
            variantName: '<',
            lineTotal: '<',
            imageSrc: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/newCheckout/components/orderSummary/components/cartItem/cartItem.js